class FileManager {
  file: string
  name: string
  extension: string
  constructor(file: string, name: string, extension: string) {
    this.file = file
    this.name = name
    this.extension = extension
  }

  getBlob(b64Data: string, contentType = '', sliceSize = 512): Blob {
    const byteCharacters = atob(b64Data)
    const byteArrays = []

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize)

      const byteNumbers = new Array(slice.length)
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }

      const byteArray = new Uint8Array(byteNumbers)
      byteArrays.push(byteArray)
    }

    return new Blob(byteArrays, { type: contentType })
  }

  download(prefix: string): void {
    const fileURL = window.URL.createObjectURL(this.getBlob(this.file))
    const fileLink = document.createElement('a')
    fileLink.href = fileURL
    fileLink.setAttribute('download', `${prefix}-${this.name}.${this.extension}`)
    document.body.appendChild(fileLink)

    fileLink.click()
  }
}

export default FileManager
